module.exports = __webpack_public_path__ + "static/media/DADEDEM_patho.5b67073b.png";